// @ts-strict-ignore
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { WHATS_APP_ACCOUNTS_KEY } from "./constants";
import type { WhatsAppAccountsPayload } from "./types";

export const getWhatsAppAccounts = reactQueryFetcherAdapter(
  WHATS_APP_ACCOUNTS_KEY,
  async (signal, appGroupId: string): Promise<WhatsAppAccountsPayload> => {
    return fetch(`/engagement/${appGroupId}/whats_app/accounts`, "GET", undefined, {
      signal,
    });
  }
);
